'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sl_SI = require('../../date-picker/locale/sl_SI');

var _sl_SI2 = _interopRequireDefault(_sl_SI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _sl_SI2['default'];